"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = require("react-redux");
var SidePanelPage_1 = require("@/pages/common/components/SidePanelPage");
exports.default = react_redux_1.connect(SidePanelPage_1.mapStateToProps, SidePanelPage_1.mapDispatchToProps)(SidePanelPage_1.sidePanelPage);
